import { ComponentProps } from 'react';
import { EEventTypes } from '.';

export interface IHomeScreen {
  title: string;
  subtitle: string;
  inputPlaceholder: string;
}

export interface IWarning {
  text: string;
  icon: (props: ComponentProps<'svg'>) => JSX.Element;
}

export enum EAdditionalInfo {
  WARNING = 'WARNING',
  INFO = 'INFO',
}

export enum EBotNamesBackend {
  SPECIALITY_MATCH = 'speciality-match',
  THERAPIST_MATCH = 'therapist-match',
}

export interface IUseCase {
  title: string;
  info: string;
  themeName: string;
  additionalInfo: {
    text: string;
    icon: (props: ComponentProps<'svg'>) => JSX.Element;
    type: EEventTypes;
  };
}

export interface IBotConfigType {
  homeScreen: IHomeScreen;
  warning: IWarning;
  useCases?: IUseCase[];
  botName: EBotNamesBackend;
  finalFeedbackText: string;
  themeName?: string;
}
